module.exports = __webpack_public_path__ + "img/electric_no_zone.c677cb00.svg";